/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bulkStockUpdate } from '../fn/stocking/bulk-stock-update';
import { BulkStockUpdate$Params } from '../fn/stocking/bulk-stock-update';
import { BulkStockUpdateResponse } from '../models/bulk-stock-update-response';


/**
 * Product sortiment stock related endpoints. The bulk-update endpoint requires TECHNICAL_USER role and is intended for automated stock synchronization from PRS.
 */
@Injectable({ providedIn: 'root' })
export class StockingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bulkStockUpdate()` */
  static readonly BulkStockUpdatePath = '/stocks/bulk-update';

  /**
   * Bulk-updates stock availability.
   *
   * Finds sortiment entries by merchantId, siteId, and productId (= packagingUnitId), then sets the availability status. Returns per-item status and error codes. Requires TECHNICAL_USER role. Intended for automated stock synchronization from PRS.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkStockUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkStockUpdate$Response(params: BulkStockUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStockUpdateResponse>> {
    const obs = bulkStockUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Bulk-updates stock availability.
   *
   * Finds sortiment entries by merchantId, siteId, and productId (= packagingUnitId), then sets the availability status. Returns per-item status and error codes. Requires TECHNICAL_USER role. Intended for automated stock synchronization from PRS.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkStockUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkStockUpdate(params: BulkStockUpdate$Params, context?: HttpContext): Observable<BulkStockUpdateResponse> {
    const resp = this.bulkStockUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BulkStockUpdateResponse>): BulkStockUpdateResponse => r.body)
    );
  }

}
